import { useState } from "react";
import { styled } from "@pigment-css/react";
import { useTranslations } from "@acto/web-common/locales";
import { BottomSheet } from "@acto/taskpane/field-sales-2/components/primitives/BottomSheet";
import { CtaRow, SolidCtaButton } from "@acto/taskpane/field-sales-2/components/primitives/SheetCta";
import {
  OptionButton,
  OptionsList,
  RadioCircle,
} from "@acto/taskpane/field-sales-2/components/primitives/SheetOptions";

const ApplyButton = styled(SolidCtaButton)(({ theme }) => ({
  background: theme.fieldSalesTwo.colors.charts.primary,
}));

export type MeetingScope = "this" | "following";

interface ScopeSheetProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  /** Forces "Alle folgenden Termine": a cadence change cannot apply to a single occurrence. */
  thisDisabled?: boolean;
  onApply: (scope: MeetingScope) => void;
  applying?: boolean;
}

export function ScopeSheet({ isOpen, onOpenChange, title, thisDisabled = false, onApply, applying }: ScopeSheetProps) {
  const t = useTranslations("fieldSalesTwo.editMeeting");
  const [scope, setScope] = useState<MeetingScope>(thisDisabled ? "following" : "this");

  return (
    <BottomSheet isOpen={isOpen} onOpenChange={onOpenChange} title={title} closeAriaLabel={t("closeScopeSheet")}>
      <OptionsList value={scope} onValueChange={(next) => setScope(next as MeetingScope)} aria-label={title}>
        <OptionButton value="this" disabled={thisDisabled}>
          {t("scopeThis")}
          <RadioCircle aria-hidden="true" />
        </OptionButton>
        <OptionButton value="following">
          {t("scopeFollowing")}
          <RadioCircle aria-hidden="true" />
        </OptionButton>
      </OptionsList>
      <CtaRow>
        <ApplyButton type="button" onClick={() => onApply(scope)} disabled={applying}>
          {t("apply")}
        </ApplyButton>
      </CtaRow>
    </BottomSheet>
  );
}
